import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Rent from './pages/Rent';
import Wire from './pages/Wire';
import CoinTerminal from './pages/CoinTerminal';
import Agent from './pages/Agent';
import BrandKit from './pages/BrandKit';
import Docs from './pages/Docs';
import Fleet from './pages/Fleet';
import { Navbar, Footer } from './components/PixelUI';

function App() {
  return (
    <div className="nv-app">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rent" element={<Rent />} />
          <Route path="/wire" element={<Wire />} />
          <Route path="/wire/:coinId" element={<CoinTerminal />} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/brand" element={<BrandKit />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/fleet" element={<Fleet />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
